import { MULTI_CASE_PACK_TAG } from "inventory/list/InventoryListActions";

export const PACK_INCLUSION_FILTER = `_tags:${MULTI_CASE_PACK_TAG}`;
